export default __webpack_public_path__ + "static/media/vrf6.a80d7c37.JPG";